/** ----------------------------------------
     Active
 ---------------------------------------- */

/**
 * This function will check if an given
 * object contains active keys that is true
 *
 * @array               array
 */

const active = array => array.filter(item => item.active === true);

/** ----------------------------------------
    Between
 ---------------------------------------- */

/**
 * This function return all the items
 * that is contained between two values.
 *
 * @array               array
 * @start               number
 * @end                 number
 * @return              array
 */

const between = (array, start, end) => array.filter(item => item > start && item < end);

/** ----------------------------------------
    Create
 ---------------------------------------- */

/**
 * This function will check if an given
 * object contains active keys that is true
 *
 * @array               array
 */

const create = (obj, key) => obj[key];

/** ----------------------------------------
    Array Contains
 ---------------------------------------- */

const index = (array, value) => array.indexOf(value);

/** ----------------------------------------
    Array Contains
 ---------------------------------------- */

const contains = (array, value) => array.indexOf(value) > -1;

/** ----------------------------------------
    Filter Object
 ---------------------------------------- */

const filterFoo = (obj, key, value) => {
    if(obj[key] == value) return true;

    // now for locations
    // we need this because lotations are nested deeper in the data
    if(obj.programs[0][key] == value) return true;

    if (obj.children && obj.children.length > 0) {
        return obj.children.reduce((obj1, obj2) => {
            return filter(obj1, key, value) || filter(obj2, key, value);
        }, {});
    }

    return false;
};

/** ----------------------------------------
    Filter Multiple Object
 ---------------------------------------- */

const filters = (obj, key, value) => {
    return obj;
};

/** ----------------------------------------
    Find Value
 ---------------------------------------- */

/**
 * Give an array of object returns all objects
 * that match a certain key value pair.
 *
 * @array               array
 * @value               value
 * @match               value
 * @return              array
 */

const find = (array, value, match) => array.filter(obj => {
    if(obj[value] === match) return true;
});

/** ----------------------------------------
    Find Index
 ---------------------------------------- */

/**
 * This function will look for a value
 * within an array of items.
 *
 * @array               array
 * @value               value
 * @return              value
 */

const findIndex = (array, value) => array[value];

/** ----------------------------------------
    Find Operator
 ---------------------------------------- */

/**
 * This function will look for a value below
 * or above giving a operator as an argument.
 *
 * @array               array
 * @key                 key
 * @operator            either > or <
 * @value               value
 * @return              array
 */

const where = (array, key, operator, value) => {
    const options = {
        '>': (key, value) => key > value,
        '<': (key, value) => key < value,
    };

    return array.filter((item) => {
        return options[operator](item[key], value);
    });
};

/** ----------------------------------------
    Export Functions
 ---------------------------------------- */

export {
    contains,
    create,
    filterFoo,
    find,
    index,
    where
}